const env_check = process.env.NEXT_PUBLIC_ENV === 'STAGING' || process.env.NEXT_PUBLIC_ENV === 'PROD';
export const CATEGORIES = {
  search: 'search',
  saved: 'saved',
  auth: 'auth',
  deposit: 'deposit',
  home: 'home',
  portfolio: 'portfolio',
  withdraw: 'withdraw',
  trade: 'trade',
  asset: 'asset',
  navigation: 'navigation',
  error: 'error'
};
export const EVENTS = {
  error: {
    authError: 'Auth Error'
  },
  search: {
    searchToken: 'Search Token',
    clickToken: 'Click Token',
    viewTopTokens: 'View Top Tokens',
    viewHotTokens: 'View Hot Tokens',
    viewRecentTokens: 'View Recent Tokens',
    viewCashTokens: 'View Cash Tokens',
    viewMemeTokens: 'View Meme Tokens',
    viewNativeTokens: 'View Native Tokens',
    clickTopToken: 'Click Top Token',
    clickStableToken: 'Click Stable Token',
    clickNativeToken: 'Click Native  Token'
  },
  auth: {
    signup: 'Signup',
    login: 'Login',
    signout: 'Signout',
    notif_token: 'Notif Token'
  },
  deposit: {
    startDeposit: 'Start Deposit',
    finalizeDeposit: 'Finalize Deposit'
  },
  home: {
    goToDeposit: 'Go To Deposit',
    goToTrade: 'Go To Trade',
    viewPortfolio: 'View Assets'
  },
  portfolio: {
    startTrade: 'Start Trade',
    goToWithdraw: 'Go to Withdraw',
    clickToken: 'Click Token',
    viewReceipt: 'View Receipt'
  },
  withdraw: {
    startWithdraw: 'Start Withdraw',
    finalizeWithdraw: 'Finalize Withdraw'
  },
  trade: {
    startTrade: 'Start Single Chain Trade',
    finalizeTrade: 'Finalize Single Chain Trade'
  },
  asset: {
    goToTrade: 'goToTrade',
    saveToken: 'Save Token'
  },
  navigation: {
    goToTrade: 'Go To Trade',
    goToExplore: 'Go To Explore',
    goToSaved: 'Go To Saved',
    goToSettings: 'Go To Settings',
    goToPoints: 'Go To Points'
  }
};
const sendToMixpanel = async (eventName, eventProperties) => {
  if (!env_check) {
    return;
  }
  const locationResponse = await fetch('/api/proxy');
  const locationData = await locationResponse.json();
  let device_data = localStorage.getItem('device_data');
  try {
    device_data = JSON.parse(device_data);
  } catch (_) {
    //
  }
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {
    utm_source: urlParams.get('utm_source') || undefined,
    utm_medium: urlParams.get('utm_medium') || undefined,
    utm_campaign: urlParams.get('utm_campaign') || undefined,
    utm_term: urlParams.get('utm_term') || undefined,
    utm_content: urlParams.get('utm_content') || undefined,
    id: urlParams.get('id') || undefined
  };
  const additionalProperties = Object.assign({
    $browser: navigator.userAgent,
    $browser_version: navigator.appVersion,
    $city: locationData.city,
    $region: locationData.region_name,
    mp_country_code: locationData.country_name,
    $current_url: window.location.href,
    $device: navigator.platform,
    $device_id: navigator.userAgent,
    $initial_referrer: (document === null || document === void 0 ? void 0 : document.referrer) ? document.referrer : undefined,
    $initial_referring_domain: (document === null || document === void 0 ? void 0 : document.referrer) ? new URL(document.referrer).hostname : undefined,
    $os: navigator.platform,
    $screen_height: window.screen.height,
    $screen_width: window.screen.width,
    device_data
  }, utmParams);
  const properties = Object.assign(Object.assign({}, eventProperties), additionalProperties);
  fetch('/api/mixpanel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      event: eventName,
      properties: properties
    })
  });
};
export const LogToMixpanel = ({
  pkp,
  eventName,
  category,
  metaData
}) => {
  var _a, _b, _c;
  if (!env_check) {
    return;
  }
  const isAppleNativeApp = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('isAppleNativeApp');
  const isGoogleNativeApp = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('isGoogleNativeApp');
  const isPWA = ((_a = window === null || window === void 0 ? void 0 : window.matchMedia('(display-mode: standalone)')) === null || _a === void 0 ? void 0 : _a.matches) || ((_b = window === null || window === void 0 ? void 0 : window.navigator) === null || _b === void 0 ? void 0 : _b.standalone) || ((_c = document === null || document === void 0 ? void 0 : document.referrer) === null || _c === void 0 ? void 0 : _c.includes('android-app://'));
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const APP_TYPE = () => {
    if (isAppleNativeApp) {
      return 'APPLE_NATIVE';
    }
    if (isGoogleNativeApp) {
      return 'GOOGLE_NATIVE';
    }
    if (isPWA) {
      return 'PWA';
    }
    if (isMobile) {
      return 'MOBILE';
    }
    return 'DESKTOP';
  };
  metaData = metaData ? Object.keys(metaData).reduce((acc, key) => {
    if (metaData[key] !== undefined) {
      acc[key] = metaData[key];
    }
    return acc;
  }, {}) : {};
  sendToMixpanel(eventName, Object.assign(Object.assign({
    category
  }, metaData), {
    app_type: APP_TYPE(),
    $name: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
    $email: pkp === null || pkp === void 0 ? void 0 : pkp.email,
    email: pkp === null || pkp === void 0 ? void 0 : pkp.email,
    username: pkp === null || pkp === void 0 ? void 0 : pkp.username,
    first_name: (pkp === null || pkp === void 0 ? void 0 : pkp.firstName) || (pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress),
    last_name: (pkp === null || pkp === void 0 ? void 0 : pkp.lastName) || (pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress),
    distinct_id: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
    vaultEthAddress: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
    additionalEthAddress: pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress,
    solanaAddress: pkp === null || pkp === void 0 ? void 0 : pkp.solanaAddress,
    $user_id: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress
  }));
};
export const useMixpanel = () => {
  return {
    EVENTS,
    CATEGORIES,
    LogToMixpanel
  };
};